<template>
  <div class="expert-view-wrap">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <template v-else>
      <div
        v-for="item in list"
        :key="item.id"
        class="expert-item">
        <div class="expert-image-wrap">
          <img
            :src="item.headPicture"
            class="expert-image">
        </div>
        <div class="title">{{ item.name }}</div>
        <div class="sub-title">{{ item.work }}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WeExpertView',
  props: {
    list: { type: Array, default() { return [] } }
  }
}
</script>
<style lang="stylus" scoped>
.expert-view-wrap {
  padding: 0 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto
  min-height: 100px
}
.expert-item {
  flex: 0 0 70px;
  width: 0;
}
.expert-item+.expert-item {
  margin-left: 12px;
}
.expert-image-wrap {
  padding-top: 100%
  position relative
  .expert-image {
    position absolute
    left: 0;
    top: 0
    width: 100%
    height: 100%
    object-fit: cover;
    border-radius: 50%
  }
}
.title{
  width: 100%
  overflow hidden
  text-overflow: ellipsis
  white-space: nowrap
  font-size: 14px;
  padding: 0
  margin-top: 4px
  text-align: center
}

.sub-title {
   font-size: 14px;
  padding: 0
  color: #999
  margin-top: 4px
    text-align: center
}
</style>
